import { inject } from "vue";
import { useSnackbarStore } from "@/store/snackbar.store";
import type { SnackbarTarget } from "@/store/snackbar.store";
import { usePipStore } from "@/store/pip.store";
import { PIP_ATTACH_KEY } from "@/constants/pip";

export function useCopy() {
  const { showSnackbarError, showSnackbarSuccess } = useSnackbarStore();
  const pipStore = usePipStore();
  const pipAttach = inject(PIP_ATTACH_KEY, null);

  async function copy(text: string, successMessage = "Successfully copied") {
    const isPipContext = Boolean(pipAttach?.value && pipStore.pipWindow);
    const target: SnackbarTarget = isPipContext ? "pip" : "main";
    const targetWindow = isPipContext && pipStore.pipWindow ? pipStore.pipWindow : window;

    try {
      await targetWindow.navigator.clipboard.writeText(text);
      showSnackbarSuccess(successMessage, target);
    } catch (error) {
      showSnackbarError("Failed copy to clipboard", -1, target);
    }
  }

  return { copy };
}
